export default "__VITE_ASSET__mLTtm_3g__"